export function avisLoadBuildValidateAction(trigger){
    return async function(dispatch){
        const action = { type : 'IS_VALIDATED', payload : trigger}
        dispatch(action);
    }
}

